import React from "react";

/**
 * Section heading block: optional eyebrow, a title rendered at the requested
 * level, and an optional supporting line.
 */
function SectionHead({ eyebrow, title, lede, as: Heading = "h2", children }) {
  return (
    <div className="section__head">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <Heading>{title}</Heading>
      {lede && <p className="lede">{lede}</p>}
      {children}
    </div>
  );
}

export default SectionHead;
